export enum USER_STATUS {
  ALL = 'all',
  NEW = 'new',
  ACTIVATION = 'activation',
  ACTIVE = 'active',
  INACTIVE = 'inactive',
}